module.exports = __webpack_public_path__ + "static/media/vibe-filled.9835ac43.svg";